// frontend/src/components/Icosahedron3D.jsx
import React, { forwardRef, useImperativeHandle } from "react";
import useIcosahedronVisualizer from "../hooks/useIcosahedronVisualizer";

const Icosahedron3D = forwardRef(
  (
    {
      running,
      chaosMode,
      glow,
      maxSpeedEnvPct,
      maxSpeedCorePct,
      pulseSpeedPct,
      flashRatePct,
      width = 600,   // valeurs par défaut
      height = 480,
    },
    ref
  ) => {
    // Hook visualizer avec les props dynamiques
    const canvasRef = useIcosahedronVisualizer({
      running,
      chaosMode,
      glow,
      maxSpeedEnvPct,
      maxSpeedCorePct,
      pulseSpeedPct,
      flashRatePct,
    });

    // Exposer __oracleSnapshot au parent via ref
    useImperativeHandle(ref, () => canvasRef.current);

    return (
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{
          border: "1px solid #333",
          borderRadius: "8px",
          background: "black",
          width: `${width}px`,
          height: `${height}px`,
        }}
      />
    );
  }
);

export default Icosahedron3D;
